import { useEffect, useMemo, useState } from "react";
import { axiosInstance } from "../../redux/constants/axiosInstance";
import { API_URL } from "../../redux/constants/type";
import BuilderOutput from "../TemplateBuilder/builder/builder-output";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

const PrintPopup = ({
  children,
  type,
  onRequestData,
  printData,
  closePopup,
  setClosePopup,
}) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("NOT_SELECTED");
  const [selectedOption, setSelectedOption] = useState("CREATE_PDF");
  const [showLoader, setShowLoader] = useState(false);

  console.log("asc closePopup", closePopup);

  const [isDefaulTemplate, setIsDefaulTemplate] = useState(false);
  const [defaulTemplateData, setDefaulTemplateData] = useState([]);

  useEffect(() => {
    if (popupOpen) {
      axiosInstance
        .get(`${API_URL}/api/User/FetchTemplates/${type}`)
        .then((response) => {
          let options = response.data?.data?.map((x) => ({
            label: x.templateName,
            value: x.templateId,
          }));
          setTemplates(options);

          if (response?.data?.status === true) {
            setIsDefaulTemplate(response.data.data.some((x) => x.isdefault));
            setDefaulTemplateData(
              response.data.data.filter((x) => x.isdefault),
            );
          }
        });
    }
  }, [popupOpen]);

  const resetPopup = () => {
    setPopupOpen(false);
    setShowLoader(false);
    setClosePopup(null);
    setSelectedTemplate("NOT_SELECTED");
    // setSelectedOption(null); // Reset selected option
    setSelectedOption("CREATE_PDF"); // Reset selected option
  };

  useEffect(() => {
    if (closePopup) {
      resetPopup();
      setShowLoader(false);
      setClosePopup(null);
    }
  }, [closePopup]);

  const handleOnRequestData = () => {
    setShowLoader(true);
    setClosePopup(null);
    onRequestData(selectedOption, selectedTemplate);
  };

  const handleSelectTemplate = (templateid) => {
    setSelectedTemplate(templateid);
  };

  const isValidForm = useMemo(() => {
    return (
      Boolean(selectedOption) &&
      (selectedOption === "PRINT_USING_TEMPLATE"
        ? selectedTemplate !== "NOT_SELECTED"
        : true)
    );
  }, [selectedOption, selectedTemplate]);

  const modalStyles = {
    printHead: {
      backgroundColor: "#e4edfa",
      borderBottom: "1px solid #ddd",
    },
    printOpt: {
      fontSize: "16px",
      fontWeight: "bold",
      color: "#00246a",
      paddingLeft: "10px",
    },
    body: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#333333",
      paddingLeft: "20px",
    },
    printBtn: {
      fontSize: "16px",
      fontWeight: "700",
      color: "white",
      cursor: "pointer",
      backgroundColor: "#00246a",
      with: "100%",
      height: "50px",
      borderRadius: "12px",
    },
    printBtnDisable: {
      fontSize: "16px",
      fontWeight: "700",
      color: "white",
      cursor: "not-allowed",
      backgroundColor: "gray",
      with: "100%",
      height: "50px",
      borderRadius: "12px",
      border: "none",
    },
  };

  return (
    <>
      <style>
        {`
          #CREATE_PDF {
            cursor: pointer;
          }
          #Create_Online_version {
            cursor: pointer;
          }
          #PRINT_USING_TEMPLATE {
            cursor: pointer;
          }
        `}
      </style>

      <div onClick={() => setPopupOpen(true)}>{children}</div>
      <Modal
        centered
        show={popupOpen}
        onHide={() => resetPopup()}
        backdrop="static"
      >
        <Modal.Header closeButton style={modalStyles.printHead}>
          <Modal.Title style={modalStyles.printOpt}>Print options</Modal.Title>
        </Modal.Header>
        <Modal.Body style={modalStyles.body}>
          <Row>
            <Col xs={12} className="pt-2 pb-3">
              <Form.Check
                label="Create PDF"
                name="PrintOption"
                type="radio"
                id="CREATE_PDF"
                onChange={(e) => setSelectedOption("CREATE_PDF")}
                checked={selectedOption === "CREATE_PDF"}
              />
            </Col>

            {type === "Quote" && (
              <Col xs={12} className="pb-3">
                <Form.Check
                  label="Create Online version"
                  name="PrintOption"
                  type="radio"
                  id="Create_Online_version"
                  onChange={(e) => setSelectedOption("Create_Online_version")}
                  checked={selectedOption === "Create_Online_version"}
                />
              </Col>
            )}

            <Col xs={12} className="pb-">
              <Form.Check
                name="PrintOption"
                type="radio"
                id="PRINT_USING_TEMPLATE"
              >
                <Form.Check.Input
                  type={"radio"}
                  className=""
                  onChange={(e) => setSelectedOption("PRINT_USING_TEMPLATE")}
                  checked={selectedOption === "PRINT_USING_TEMPLATE"}
                />
                <Form.Check.Label>Print using template</Form.Check.Label>
                <Form.Select
                  className="mt-3 pointer"
                  onChange={(e) => handleSelectTemplate(e.target.value)}
                  disabled={!(selectedOption === "PRINT_USING_TEMPLATE")}
                >
                  <option value={"NOT_SELECTED"} selected={true}>
                    Select template
                  </option>
                  {templates.map((x) => (
                    <option
                      key={x.value}
                      value={x.value}
                      selected={x.value === selectedTemplate}
                    >
                      {x.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Check>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="pt-0 pb-4">
          <div className="d-flex align-items-center justify-content-center">
            {selectedOption === "PRINT_USING_TEMPLATE" || isDefaulTemplate ? (
              <BuilderOutput
                items={printData}
                onRequestData={() => handleOnRequestData()}
                onDownloadComplete={resetPopup}
                disabled={!isValidForm}
              >
                <Button
                  style={
                    !isValidForm
                      ? modalStyles.printBtnDisable
                      : modalStyles.printBtn
                  }
                  className="px-5"
                  variant="primary"
                  disabled={!isValidForm}
                >
                  Print
                  {showLoader && (
                    <span className="ms-2">
                      <Spinner animation="border" size="sm" />
                    </span>
                  )}
                </Button>
              </BuilderOutput>
            ) : (
              <Button
                style={
                  !isValidForm
                    ? modalStyles.printBtnDisable
                    : modalStyles.printBtn
                }
                className="px-5"
                variant="primary"
                disabled={!isValidForm}
                onClick={() => handleOnRequestData()}
              >
                Print
                {showLoader && (
                  <span className="ms-2">
                    <Spinner animation="border" size="sm" />
                  </span>
                )}
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PrintPopup;
